// check if browser is Safari
window.is_safari = true;
$(document).ready(function(){
  window.is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
});
// when external link is clicked store scroll position and flag to localStorage
$('.external-link').on('click', function() {
    // save scroll position to local storage
    window.localStorage.setItem("scroll", $(document).scrollTop());
    // check the size of window (most likely on touch screen if below this size)
    if($(window).width() <= 1000)
    {
    // save flag variable to local storage
    window.localStorage.setItem("returnPos", 0);
    }
 });
 function repeatFunction(){
    if(window.localStorage.getItem('returnPos') == 0)
    {
        // keep the scroll position the same as localStorage variable
        $(document).scrollTop( window.localStorage.getItem('scroll') );
        // once user drags change flag to one so this if statement doesn't get entered
        // and scroll position can move freely
        $(document).on('mousedown touchstart', function() 
        {
            window.localStorage.setItem("returnPos", 1); 
        });
    }
    // if Safari keep calling function 
    if(window.is_safari){
    setTimeout(repeatFunction, 100);
    }
}
$(document).ready(function(){
    repeatFunction();
});